import clsx from 'clsx';
import styles from './FadeScrollContainer.module.scss';
import React, { useEffect, useRef } from 'react';
export const FadeScrollContainer = ({ fadeWidth, className, children })=>{
    const ref = useRef(null);
    useEffect(()=>{
        const el = ref.current;
        if (!el) return;
        const updateFades = ()=>{
            const maxScrollLeft = el.scrollWidth - el.clientWidth;
            const hasOverflow = maxScrollLeft > 0;
            if (!hasOverflow) {
                el.style.removeProperty('--fade-left');
                el.style.removeProperty('--fade-right');
                return;
            }
            const leftFadeWidth = Math.min(el.scrollLeft, fadeWidth);
            const rightFadeWidth = Math.min(maxScrollLeft - el.scrollLeft, fadeWidth);
            el.style.setProperty('--fade-left', `${leftFadeWidth}px`);
            el.style.setProperty('--fade-right', `${rightFadeWidth}px`);
        };
        updateFades();
        el.addEventListener('scroll', updateFades, {
            passive: true
        });
        const resizeObserver = new ResizeObserver(updateFades);
        resizeObserver.observe(el);
        return ()=>{
            el.removeEventListener('scroll', updateFades);
            resizeObserver.disconnect();
        };
    }, [
        fadeWidth
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        ref: ref,
        className: clsx(styles.container, className)
    }, children);
};
